import request from '@/utils/request'

export function getWriteFromulaResult(templateId, queryId, data) {
  return request({
    url: `/writeformulas/${queryId}/invoke?templateId=${templateId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
